export default __webpack_public_path__ + "static/media/112.0e592f90.webp";